import {
  DataTableStrings,
  DefaultColumnKeys,
  IColumnType,
  IDataTableColumn,
} from '../../../../../../ui/gzDataTable/types';
import { translateFn } from '../../../../../../utils/translator.helper';
import {
  AssignedSecurityServer,
  AssignedSecurityServerColumn,
  AssignedSecurityServerItem,
  AssignedSecurityServersOnEntity,
  SecurityServer,
} from '../types';
import { EnumListItem } from '../../../../../../ui/gzEnumList/types';

export class AssignSecurityServersHelper {
  public static getAlreadyAssignedSecurityServersColumns(): Array<IDataTableColumn> {
    return [
      {
        key: AssignedSecurityServerColumn.TARGET_NAME,
        header: translateFn('Selected targets'),
        columnType: IColumnType.TEXT,
        width: '240px',
      },
      {
        key: AssignedSecurityServerColumn.SERVER_INFO,
        header: translateFn('Assigned Security Servers'),
        columnType: IColumnType.TEXT,
        width: '560px',
      },
    ];
  }

  public static getSecurityServersToBeAssignedColumns(): Array<IDataTableColumn> {
    return [
      {
        key: 'name',
        header: translateFn('Security Servers to be assigned'),
        columnType: IColumnType.TEXT,
        width: '720px',
      },
      {
        key: DefaultColumnKeys.ACTIONS,
        header: translateFn('Action'),
        columnType: IColumnType.DISPLAY,
        width: '80px',
      },
    ];
  }

  public static getStringsForDataTable(): DataTableStrings {
    return {
      copyConfirmationTooltip: '',
      emptyStateFooterButton: '',
      deleteRowTooltip: translateFn('Delete'),
      resetPriorityButton: '',
      editRowTooltip: '',
      cancelEditTooltip: '',
      validateEditTooltip: '',
      disabledEditTooltip: '',
      requiredFieldMessage: '',
      extraValidationToastMessage: '',
      textInputPlaceholder: '',
      dropdownApplyButtonString: '',
      dropdownAllItemsLabel: '',
    };
  }

  public static transformSecurityServerToEnumListItem(securityServer: SecurityServer): EnumListItem {
    return {
      id: securityServer._id,
      label: securityServer.name + ' (' + securityServer.specifics.ip + ')',
      value: securityServer._id,
      selected: false,
    };
  }

  public static transformConsoleRequestToTableItems(
    assignedSecurityServers: Array<AssignedSecurityServersOnEntity>
  ): Array<AssignedSecurityServerItem> {
    return assignedSecurityServers.map(item => {
      return {
        [AssignedSecurityServerColumn.TARGET_NAME]: item.name,
        [AssignedSecurityServerColumn.SERVER_INFO]: AssignSecurityServersHelper.getAssignedSecurityServersLabel(
          item.securityServers
        ),
      };
    });
  }

  private static getAssignedSecurityServersLabel(securityServers: Array<AssignedSecurityServer>): string {
    let label = '';
    if (securityServers.length === 0) {
      return label;
    }

    for (const item of securityServers) {
      label += item.name + ' (' + item.ip + '), ';
    }

    return label.substring(0, label.length - 2);
  }
}
